<template>
    <v-app>
        <slot />
    </v-app>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {BaseLayout} from '@/components/BaseLayout.vue'

    @Component
    export class PureLayout extends BaseLayout {}

    export default PureLayout
</script>
